<template>
  <span class="ws-period ws-typo-xs">
    {{
      period % 12 !== 0
        ? $t('wsk.general.period.months', {period})
        : $t('wsk.general.period.years', {period: period / 12})
    }}
  </span>
</template>

<script lang="ts">
import {defineComponent} from 'vue';


export default defineComponent({
  props: {
    short: Boolean,
    period: {type: Number, default: 1}
  }
});
</script>

<style lang="scss" scoped>
.ws-period {
  white-space: nowrap;
}
</style>
